import React, { useEffect, useRef, useState } from 'react'
import { SvgEllipses } from '../assets/images'
import { DataType, OptionsListType } from '../utils'

interface SettingsPropTypes {
  settingsList: OptionsListType[]
  record?: DataType
  handleChange: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    selectionType: string,
    index?: number,
    record?: DataType
  ) => void
  position: 'top' | 'bottom' | 'left' | 'right'
  rowIndex?: number
}

const Settings = ({
  settingsList,
  record,
  handleChange,
  position,
  rowIndex,
}: SettingsPropTypes) => {
  const [settingsClicked, setSettingsClicked] = useState<boolean>(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setSettingsClicked(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleOptionClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
    selectionType: string
  ) => {
    e.stopPropagation()
    handleChange(e, selectionType, index, record)
    setSettingsClicked(false)
  }

  const positionClass = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
  }

  return (
    <div className="relative font-primary z-[12]" ref={dropdownRef}>
      <button
        onClick={(e) => {
          e.stopPropagation()
          setSettingsClicked((prevState) => !prevState)
        }}
        type="button"
      >
        <span>
          <SvgEllipses
            width={'1.25rem'}
            height={'1.25rem'}
            className={`${
              record?.enabled === undefined ||
              record?.enabled === null ||
              record?.enabled === true
                ? 'cursor-pointer'
                : 'cursor-not-allowed'
            }`}
          />
        </span>
      </button>
      {settingsClicked && (
        <div
          className={`dropdown w-max absolute  ${positionClass[position]} bg-accent-0 z-40 rounded-lg border custom-shadow `}
        >
          {settingsList.map((option) => (
            <div
              key={option.label}
              className="flex items-center gap-2 bg-accent-0 rounded-lg hover:bg-secondary-25 h-10 px-6 cursor-pointer"
              onClick={(e) =>
                handleOptionClick(e, rowIndex ?? 0, option.label.toLowerCase())
              }
            >
              <span>{option.icon}</span>
              <span className="text-xs">{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Settings
